import { BottomViewFlyers, FlyerboardPagination, HeaderFixed } from '@/components';
import { FlyerType } from '@/config/constants';
import { EventDetails, TrackingEvents, TrackingStage } from '@/config/tracking';
import { NavigationContext } from '@/context/NavigationContext';
import { FlyerboardHeader, NavBarBackButton } from '@/design-system';
import { districtVar } from '@/graphql/state';
import { AllFlyerFilters, OwningTypeEnum } from '@/graphql/types';
import { useAnalytics, useSubscriptionsIds } from '@/hooks';
import { Subscription } from '@/types/subscriptions';
import { useReactiveVar } from '@apollo/client';
import { useContext, useEffect, useMemo, useState } from 'react';
import styles from './CommunityFreeFlyerboard.styles';

export const CommunityFreeFlyerboard: React.FC = () => {
  const trackId = 'communityFreeFlyerboard';
  const trackingEventFrom = EventDetails.viewFlyerSet(FlyerType.community, 'free');
  const [userDistrict, setUserDistrict] = useState<Subscription[]>([]);
  const district = useReactiveVar(districtVar);
  const schoolIds = useSubscriptionsIds();
  const flyerType = FlyerType.community;
  const { trackEvent } = useAnalytics();
  const { wasFlyerDetailsPage, isLoading: isUpdatingNav } = useContext(NavigationContext);

  useEffect(() => {
    if (!isUpdatingNav) {
      trackEvent({
        event: TrackingEvents.viewFlyerSet,
        event_detail: trackingEventFrom,
        stage: TrackingStage.discovery,
        ...(wasFlyerDetailsPage
          ? {
              event_from: TrackingEvents.viewFlyerDetails,
              event_detail_from: EventDetails.viewFlyerDetails(FlyerType.community),
              stage_from: TrackingStage.consideration,
            }
          : {}),
      });
    }
  }, [isUpdatingNav, wasFlyerDetailsPage]);

  useEffect(() => {
    if (district?.name && district?.branding) {
      setUserDistrict([
        {
          id: district.districtId,
          name: district.name,
          logo: district.branding.logoUrl,
          type: 'school',
        },
      ]);
    }
  }, [district]);

  let filters = useMemo(
    (): AllFlyerFilters => ({
      owningType: OwningTypeEnum.organization,
      isCommunityFree: true,
      schoolIds,
    }),
    [schoolIds]
  );

  return (
    <div className={styles.container}>
      <HeaderFixed>
        <NavBarBackButton trackId={trackId}>Free</NavBarBackButton>
        <FlyerboardHeader
          subscriptions={userDistrict}
          type={flyerType}
          selectedAudienceId={district?.districtId.toString() ?? ''}
          trackingEventFrom={trackingEventFrom}
        />
      </HeaderFixed>
      <FlyerboardPagination
        trackId={trackId}
        flyerType={flyerType}
        flyerboardFilters={filters}
        trackingEventFrom={trackingEventFrom}
        className={styles.flyerboard}
      />
      <BottomViewFlyers variant={FlyerType.community} />
    </div>
  );
};
